import React from 'react'
import Navbar from './Navbar';
import Client from './Client'
import Marquee from "react-fast-marquee";

const HeroUpdated = () => {
  return (
    <div className=''>
        <div className='flex px-20 py-4'>
            <div className='basis-[60%]'>
                <Navbar />
                <div className='pl-4 my-24 flex flex-col gap-4'>
                    <span className='text-7xl font-medium tracking-wide leading-tight opacity-90'>Let's Design Your Business</span>
                    <span className='text-lg font-normal tracking-wider opacity-80 max-w-[30rem]'>Where your brand's full potential becomes its reality Let's embark on this journey of growth together.
                    </span>
                </div>
            </div>
        </div>
        <div className='pl-20 py-6 '>
            <div className='flex pl-4 items-center '>
                <span className='flex flex-col w-[30rem]'>
                    <span className='text-lg uppercase tracking-wider font-normal opacity-90 text-[#273773]'>Trusted by leading</span>
                    <span className='text-lg uppercase tracking-wider font-normal opacity-90 text-[#273773]'>brands and startups.</span>
                </span>
                <Marquee className='px-12 ' speed={80} pauseOnHover>
                    <Client />
                </Marquee>
                    
            </div>
        </div>
    </div>
  )
}

export default HeroUpdated;